class CartRapping {
  constructor() {
    this.handleChange = this.handleChange.bind(this);
    this.loadEventListeners();
  }

  loadEventListeners() {
    document.addEventListener('DOMContentLoaded', () => {
      this.addEventListenersToSelects();
    });
  }

  addEventListenersToSelects() {
    document.addEventListener('change', (event) => {
      if (event.target.closest('.cart-attribute-gift-box select')) {
        this.handleChange(event);
      }
    });
  }

  handleChange(event) {
    console.log('Change detected');
    setTimeout(() => {
      this.updateSelects();
    }, 100);
  }

  updateSelects() {
    let selects = document.querySelectorAll('.cart-attribute-gift-box select');
    if (selects.length >= 2) {
      for (let i = 0; i < selects.length - 1; i++) {
        let title = selects[1 + i];
        let option = title.children[0];
        option.innerHTML = title.name;
      }
    }
  }
}

const cart = new CartRapping();